import { API } from '@/api';
import axios from 'axios';

const state = {
};

const getters = {
};

const actions = {
  async getRecurrentesList({ commit, State }, {condo, admin, options}) {
    const sortBy = options.sortBy[0] ? options.sortBy[0] + ',' + (options.sortDesc[0] ? 'desc' : 'asc') : '';
    const queryString = {page: options.page - 1, size: options.itemsPerPage, sort: sortBy};
    const response = await API.get('/recurrente/list/' + admin.id + '/' + condo.id, {params: queryString});
    return response.data;
  },
  async addRecurrentes({ commit, State }, {datos}) {
    const response = await API.post('/recurrente/add/' + datos.admin.id + '/' + datos.condo.id, datos.borradores);
    return response.data;
  },
  async generarBorradores({ commit, State }, {datos}) {
    const response = await API.post('/recurrente/convert/' + datos.admin.id + '/' + datos.condo.id, datos.borradores);
    return response.data;
  },
  async deletePersistente({ commit, State }, {admin, condo, recibo}) {
    const response = await API.delete('/recurrente/delete/' + admin.id + '/' + condo.id + '/' + recibo.id);
    return response.data;
  },
};

const mutations = {
};

export default {
  actions,
  getters,
  mutations,
  state,
};
